<template>
    <nav >
        <div class="line"></div>
        <nav-date-item
            v-for="page in pages"
            v-bind:key="page.date"
            v-bind:page="page"
            v-on:select-item="selectItem"
        ></nav-date-item>
        <a class="home" href="#" @click.prevent="$router.push('/')">
        <icon-base size="3vw" icon-color="#fff">
            <icon-home/>
        </icon-base>
        </a>
    </nav>
</template>

<script>
    import NavDateItem from "@/components/nav/NavDateItem";
    import IconBase from "shared-src/icons/IconBase";
    import IconHome from "shared-src/icons/IconHome";
    export default {
        name: "NavDates",
        components: {NavDateItem,IconBase,IconHome},
        props:{
            pages:Array
        },
        data:function(){
            return{
                activeOne:null,

            }
        },
        methods:{
            selectItem: function (page) {
                console.log(page.date);
                for(let pp of this.pages){
                    pp.active=false;
                }
                page.active=true;
                this.activeOne=page;
            }
        }

    }
</script>

<style scoped lang="less">
    nav{
        //outline: 1px solid yellow;
        user-select: none;
        //padding: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        .line{
            pointer-events: none;
            position: absolute;
            width: 100%;
            height: 1px;
            background-color: white;
            margin: 0;
        }
        .home{
            svg{
                display: block;
            }
            position: absolute;
            right: 0vw;
            top: calc(50% - 3vw);
        }
    }
</style>